import { AppState } from 'Store'

export const agreementSelectors = {
	getAllAgreementCatalog: (state: AppState) => state.adminSlice.agreements.agreementList,
	getAllAgreement: (state: AppState) => state.adminSlice.agreements.agreementList.entries,
	getAllAgreementRequestParams: (state: AppState) => state.adminSlice.agreements.agreementParams,
	getAllAgreementCount: (state: AppState) =>
		state.adminSlice.agreements.agreementList.total_entries,
	getAgreement: (state: AppState) => state.adminSlice.agreements.description,
	getAgreementDocument: (state: AppState) => state.adminSlice.agreements.description?.body ?? '',
	getIsEditAgreement: (state: AppState) => state.adminSlice.agreements.isEditAgreement,
}
